import React from 'react';
import { useIntl } from 'react-intl';
import { Icon } from 'semantic-ui-react';
import { validationStatusIconProps } from '../helper';

const DataManagementDictionaryIcon = ({ valid, isLoading }) => {
  const intl = useIntl();
  if (isLoading) {
    return (<Icon className="primary" name="circle notched" loading />);
  }

  return (
    <Icon
      color={validationStatusIconProps(valid).colour}
      className={(valid === true || valid === false) ? '' : 'primary'}
      name={validationStatusIconProps(valid).name}
      title={intl.formatMessage({ id: validationStatusIconProps(valid).message })}
    />
  );
};

export default DataManagementDictionaryIcon;
